module.exports = __webpack_public_path__ + "fa-brands-400.68d98f5a7335a71eea4d.svg";


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/scss/webfonts/fa-brands-400.svg
// module id = ../../../../../src/scss/webfonts/fa-brands-400.svg
// module chunks = styles